/** @flow */
export default {
  primary: '#13A89E',
  darkerPrimary: '#328479',
  primaryText: '#4d4c4d', // #808080
  secondaryText: '#212121',
  tertiaryText: '#FFF',
  primaryBackground: '#fafafa',
  secondaryBackground: '#EEE',
  darkBackground: '#000',
  lightBackground: 'rgba(19,168,158,0.1)',
  disabled: '#a3a2a0',
  disabledOnPrimary: '#c8c8c8',
  accent: '#1368a8',
  secondaryAccent: '#00a198',
  divider: '#c8c8c8',
  border: '#AFAFAF',
  lightGray: '#AEAEAE',
  whiteHoverBackground: '#fafafa',
  dimGray: '#888',
  darkGray: '#4C4C4C',
  increaseStats: '#7DCE94', // #188c7b
  decreaseStats: 'rgb(169, 30, 33)',
  female: '#5bbcb0',
  male: '#108479',
  delete: '#a91e21',
  warning: '#FFA000',
  graphBorderAndText: 'rgb(102, 102, 102)',
  cardBackground: '#FFF',
  tooltipBackground: 'rgba(0, 0, 0, 0.7)',
  error: 'red',
  badge: '#f6412d',

  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 2px 4px 0 rgba(0, 0, 0, 0.23)',
  horizontalBoxShadow: 'rgba(0, 0, 0, 0.156863)',
  verticalBoxShadow: 'rgba(0, 0, 0, 0.23)',

  message: {
    important: {
      color: '#FFA000',
      background: '#fff0d8',
    },
    info: {
      color: '#31708f',
      background: '#d9edf7',
    },
  },

  reach: '#1368a8',
  listeningTime: '#ff6f00',

  graph: {
    lines: '#DDD',
    disabled: '#FAFAFA',
    verticalReferenceLine: 'gray',
  },

  hexToRGBA: (color: string, opacity: number): string => {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
  },
};



// WEBPACK FOOTER //
// ./src/common/themes/Colors.js